import { defineStore } from 'pinia';

export const useStorageStore = defineStore('storage', {
  state: () => ({
    dataChest: {},
  }),

  actions: {
    save(key, value = null) {
      this.dataChest[key] = value;
    },
    saveOnLocalStorage(key, value = null) {
      localStorage.setItem(key, JSON.stringify(value));
    },
    getOnLocalStorage: (key) => {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    },
    removeOnLocalStorage: (key) => {
      localStorage.removeItem(key);
    }

  },
  getters: {
    get: (state) => {
      return (key) => state.dataChest[key] ?? null;
    },
    all: (state) => {
      return state.dataChest;
    }
  }

})
